import type { BannerStoreState } from "./types";

export const state = (): BannerStoreState => {
  const config = useRuntimeConfig();
  return {
    banners: [],
    videoProgress: [],
    documents: {
      privacyPolicy: `${config.public.apiBase}/v4/api/documents/privacy-policy`,
      termsOfUse: `${config.public.apiBase}/v4/api/documents/terms-of-use`,
    },
  };
};
